import React, { useEffect } from 'react';

const CLIENT = 'ca-pub-8325885031744065';
const SLOT = '2549153977';

const Adsense = ({ client, slot, format }) => {
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <ins className="adsbygoogle"
         style={{ display: 'block' }}
         data-ad-client={client ?? CLIENT}
         data-ad-slot={slot ?? SLOT}
         data-ad-format={format}></ins>
  );
};

export default Adsense;
